module.exports = __webpack_public_path__ + "media/images/plus_icon-e9efc47e5e355e00edbd3adf4ab5b329.png";